<div class="main">
  <spb-header/>
  <router-outlet/>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.reset()"
    copyrightYears="2021"
    [license]="true"
    [token]="configService.accessToken()"
    [version]="version"
  />
</div>